export const ROUTE_TITLES = {
    '/': 'Dashboard',
    '/participants': 'Participantes',
    '/login': 'Iniciar Sesión',
    '/system/users': 'Gestión de Usuarios',
    '/system/roles': 'Gestión de Roles',
    // Se pueden agregar más rutas conforme se implementen módulos
};

export const BASE_TITLE = 'STC Admin';
